export enum BusinessStatusEnum {
  AUTHORIZED = 'AUTHORIZED',
  ABANDONED = 'ABANDONED',
  ANTIFRAUD_REJECTED = 'ANTIFRAUD_REJECTED',
  BANK_FRAUD_REJECTED = 'BANK_FRAUD_REJECTED',
  BANK_REJECTED = 'BANK_REJECTED',
  CANCELLED = 'CANCELLED',
  ERROR = 'ERROR',
  EXPIRED = 'EXPIRED',
  PLATFORM_REJECTED = 'PLATFORM_REJECTED',
  PAID = 'PAID',
  CHARGEBACK = 'CHARGEBACK',
  PENDING = 'PENDING',
  REFUND = 'REFUND',
  IN_DISPUTE = 'IN_DISPUTE',
  PARTIAL_REFUND = 'PARTIAL_REFUND',
  THREEDS_REJECTED = 'THREEDS_REJECTED',
  RETURNING = 'RETURNING',
  NOT_FOUND = 'NOT_FOUND'
}
